import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import AnimatedCounter from "../../components/AnimatedCounter";
import MotionDiv from "../motionDiv";
import {Row} from "react-bootstrap";

function HeroBlock() {
    const year = new Date().getFullYear();
    const totalYearsOfExistense = year - 2009;

    return (
        <section className="banner-section">
            <div className="auto-container">
                <Row className={'gap-lg-5 gap-md-5 gap-sm-3'}>
                    <MotionDiv delay={0.2} variant={'toBottom'}>
                        <div className="sec-title text-center">
                            <h1 className="homepage white">
                                Le partenaire des employeurs inclusifs
                                <br/>
                                et engagés pour l’emploi des talents en situation de handicap.
                            </h1>
                        </div>
                    </MotionDiv>
                    <MotionDiv delay={0.4} duration={0.8} variant={'zoomIn'}>
                        <Row className="key-figures">
                            <AnimatedCounter sign={'+'} value={150000} text={"Talents dans<br/>notre réseau"}/>
                            <AnimatedCounter sign={'+'} value={200} text={"Employeurs<br/>partenaires"}/>
                            <AnimatedCounter sign={'+'} value={totalYearsOfExistense} text={"Années<br/>d’expertise"}/>
                        </Row>
                    </MotionDiv>
                    <MotionDiv delay={0.4} variant={'zoomOut'}>
                        <figure className={"hero-picture"}>
                            <img src={"images/homepage/reunion-emploi-inclusion-handicap.webp"}
                                 alt="Jeunes professionnels en réunion sur l’emploi et l’inclusion des personnes handicapées"
                                 width={'1280'} height={'400'}
                            />
                            <div className={'picture-title'}>
                                <div className={'picture-title-cta'}>
                                    <span>Découvrir nos services dédies Handicap</span>
                                </div>
                            </div>
                        </figure>
                    </MotionDiv>
                    <MotionDiv delay={0.5}>
                        <ul className={'picture-title-list'}>
                            <li>
                                <MotionDiv delay={0.8} duration={0.8}>
                                <a href="/#forum">
                                    <i className={'picto-malette'}/>
                                    <span>Forums emploi</span>
                                </a>
                                </MotionDiv>
                            </li>
                            <li>
                                <MotionDiv delay={0.9} duration={0.8}>
                                <a href="/#formation">
                                    <i className={'picto-diplome'}/>
                                    <span>Formation & Sensibilisation</span>
                                </a>
                                </MotionDiv>
                            </li>
                            <li>
                                <MotionDiv delay={1} duration={0.8}>
                                <a href="/#hotline">
                                    <i className={'picto-chat'}/>
                                    <span>Hotline</span>
                                </a>
                                </MotionDiv>
                            </li>
                            <li>
                                <MotionDiv delay={1} duration={0.8}>
                                    <a href="/#webinaires">
                                        <i className={'picto-webinaire'}/>
                                        <span>Webinaires de sensibilisation </span>
                                    </a>
                                </MotionDiv>
                            </li>
                        </ul>
                        <p className={'text-center'}>
                            <b>Groupe Talents Handicap</b> accompagne tout employeur handi-engagé dans la réussite de sa politique handicap,
                            de manière qualitative et personnalisée,<br/>
                            avec une <b>expertise concrète de l’emploi et du handicap au travail</b>.
                        </p>
                    </MotionDiv>
                </Row>
            </div>
        </section>
    );
}

export default HeroBlock;
